import { Injectable } from '@angular/core';
import { DataClientService } from './data-client.service';
import { DataNotClientService } from './data-not-client.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EnumService {

    constructor(
        private dataClientService: DataClientService,
        private dataNotClientService: DataNotClientService
    ) { }

    public getEnumValue(enumString: string): string {
        switch (enumString) {
            case 'DNI':
                return '1';
            case 'CE':
                return '4';
        }
    }
    public getDocumentValue(enumString: string): string {
        switch (enumString) {
            case '1':
                return 'DNI';
            case '4':
                return 'CE';
        }
    }

    public getGenderEnumValue(enumString: string): string {
        switch (enumString) {
            case 'Masculino':
                return '1';
            case 'Femenino':
                return '2';
        }
    }

    public getAccountType(accountString: string): string {
        switch (accountString) {
            case 'AhorroSueldo':
                return this.getCurrency() === 1 ? '82' : '83';
            case 'Ahorro':
                return this.getCurrency() === 1 ? '80' : '81';
            case 'Flex':
                return this.getCurrency() === 1 ? '82' : '83';
            case 'CTS':
                if (this.dataClientService.getIsFisherman() || this.dataNotClientService.getIsFisherman()) {
                    return this.getCurrency() === 1 ? '74' : '75';
                } else if (
                    (this.dataClientService.getRucCompany() === '20330401991' ||
                        this.dataNotClientService.getRucCompany() === '20330401991') &&
                    (this.dataClientService.isIsCTS() ||
                        this.dataNotClientService.isIsCTS())
                ) {
                    return this.getCurrency() === 1 ? '70' : '71';
                } else if (
                    this.dataClientService.isIsCTS() ||
                    this.dataNotClientService.isIsCTS()) {
                    return this.getCurrency() === 1 ? '86' : '87';
                } else {
                    return this.getCurrency() === 1 ? '84' : '85';
                }

        }
    }

    private getCurrency() {
        if (environment.mode === 'WEB' || environment.mode === 'WEB-PF') {
            return this.dataNotClientService.getCurrencyType();
        }
        return this.dataClientService.getCurrencyType();
    }


}
